module.exports = __webpack_public_path__ + "ce06685cdcd87de5b52f8843b0e9678b.svg";